export const RECEIVE_WELCOME_MAT = "RECEIVE_WELCOME_MAT";



// WEBPACK FOOTER //
// ./template/state/modules/welcomeMat/constants.js